module.exports = __webpack_public_path__ + "static/media/11.f9d5bdd4.jpg";